<template>
    <div class="pagehtml" :class="{'pagehtml-bg': prodType === '1'}">
        <div class="preview-main-header" v-if="prodType === '1'">
            <i class="iconfont icon-bianzu-15_2x" title="预览电脑网站" @click="previewPc" :class="{'act': width === '100%'}"></i>
            <i class="iconfont icon-ipad" title="预览ipad网站" @click="previewIpad" :class="{'act': width === '980px'}"></i>
            <i class="iconfont icon-shouji" title="预览手机网站" @click="previewShouji" :class="{'act': width === '640px'}"></i>
        </div>
        <button @click="createProject">{{webType === '单页' ? '添加该落地页' : '使用该方案'}}</button>
        <iframe id="pubpage" :src="pubPageUrl" height="100%" ref="iframe" :class="previewClass" :style="{'width':width}"></iframe>
        <yq-dialog-hint :showDialog.sync="showDialog" :config="dialogConfig" @defined="definedBack"></yq-dialog-hint>
        <NoticeForUse :openNotice.sync="openNotice"></NoticeForUse>

        <!--		<img v-if="previewClass==='ipad'" style="position: absolute;top: 50%; left: 50%; margin: -376px 0 0 -261px; z-index: 9" src="../../assets/images/ipad.png" height="752" width="523"/>-->
        <!--		<img v-if="previewClass==='phone'" style="position: absolute;top: 50%; left: 50%; margin: -376px 0 0 -188px; z-index: 9" src="../../assets/images/phone.png"/>-->
        <div class="ipad-img" v-if="previewClass==='ipad'"></div>
        <div class="phone-img" v-if="previewClass==='phone'">
            <div class="phone-btn1"></div>
            <div class="phone-btn2"></div>
            <div class="phone-btn3"></div>
        </div>
        <div :class="{'ipad-bg':previewClass==='ipad','phone-bg':previewClass==='phone'}" v-if="previewClass==='ipad' || previewClass==='phone'"></div>

        <!-- 第一次使用指引 -->
        <transition name="dialog" mode="out-in">
            <div class="guide-mask" v-if="guideMaskShow" @click="getCancelPrompt">
                <img src="../../assets/images/point7.png" />
            </div>
        </transition>
        <div class="image-box" v-show="projType === '手机' || previewClass==='phone'">
            <img id="image" />
            <span>[手机扫码预览效果]</span>
        </div>
        <yq-dialog-progress-bar :showProgress.sync="progressOptions.showProgress" v-if="progressOptions.showProgress" :options="progressOptions"></yq-dialog-progress-bar>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import NoticeForUse from './NoticeForUse'
import QRCode from 'qrcode'
import mixinsDialog from '@/mixins/mixinsDialog.js'
import pageApi from '@/api/page.api.js'

export default {
    name: 'pagePreview',
    data () {
        return {
            pubPageUrl: '',
            dialogData: {},
            guideMaskShow: false,
            siteCount: 1,
            width: '100%',
            previewClass: '',
            progressOptions: {
                showProgress: false,
                percent: 0,
                percentInfo: '网站创建中，请稍等几秒钟...'
            },
            openNotice: false
        }
    },
    mixins: [mixinsDialog],
    created () {
        this.pubPageUrl = this.getPubPage({
			pageId: this.pageId,
			webType: this.webType,
			company: this.company,
			abbreviation: this.abbreviation,
			product: this.product
		})
        document.title = this.tblName

        //判断是否显示过
        if (this.userInfo && this.userInfo.tempTips === '0') {
            this.guideMaskShow = true
        }
        if (this.$route.params.projType === '手机') {
            console.log(this.$route.params.webWidth)
            this.$route.params.webWidth === '750' ? this.width = '750px' : this.width = '640px'
        }
        if (this.prodType === '1') {
            this.previewClass = 'pc'
        }
    },
    mounted () {
        var opts = {
            errorCorrectionLevel: 'H',
            type: 'image/jpeg',
            rendererOpts: {
                quality: 0.3
            }
        }
        QRCode.toDataURL(this.pubPageUrl, opts, function (err, url) {
            if (err) throw err
            let img = document.getElementById('image')
            image.src = url
        })
    },
    components: {
        NoticeForUse
    },
    computed: {
        pageId () {
            return this.$route.params.pageId
        },
        webType () {
            return this.$route.params.webType
        },
		company () {
            return this.$route.query.company
        },
        product () {
            return this.$route.query.product
        },
		abbreviation () {
            return this.$route.query.abbreviation
        },
        tblName () {
            return this.$route.params.tblName
        },
        projType () {
            return this.$route.params.projType
        },
        prodType () {
            return this.$route.params.prodType
        },
        isLandingPage () {
            //是否为落地页  0-整站，1-落地页
            return this.$route.query.webType === '1'
        },
        ...mapGetters('user', ['userInfo']),
        ...mapGetters('siteList', ['getPubPage']),
        ...mapGetters('templateConfig', ['filterCombo'])
    },
    methods: {
        ...mapMutations(['SET_IS_REFRESH']),
        ...mapActions('siteList', ['postCreateProject', 'createProjectLdy', 'userpageLdy']),
        ...mapActions('user', ['getUpdTipStatus', 'getFrontUserInfo']),
        ...mapActions('templateConfig', ['getCommonInfo']),
        ...mapMutations('deputyNav', ['SET_CUR_DEPUTY_NAV']),
        loginCallback () {
            this.createProject()
        },
        previewPc () {
            this.width = '100%'
            this.previewClass = 'pc'
        },
        previewIpad () {
            this.width = '980px'
            this.previewClass = 'ipad'
        },
        previewShouji () {
            this.width = '640px'
            this.previewClass = 'phone'
        },
        createProject () {
            //判断是否学习完
            this.$toast('true')
            if (sessionStorage.getItem('isLearn') === 'false') return
            if (!this.userInfo) {
                this.$router.push({ name: 'login', query: { redirect: window.location.href } })
                return
            }
            this.openNotice = true
        },
        getProject () {
            this.progressOptions.showProgress = true
            this.progressOptions.percent = '0%'
            let count = 0
            let timer = setInterval(() => {
                count += 20
                if (count >= 80) {
                    clearInterval(timer)
                    count = 80
                }
                this.progressOptions.percent = count + '%'
            }, 1000)
            let { projId } = this.$route.query
            if (this.webType === '整站' || this.isLandingPage) {
                this.addProject(timer)
            } else if (this.webType === '单页' && projId) {
                this.addLeaflet(timer, projId)
            } else {
                this.$message.error('参数丢失，无法添加')
            }
        },
        async addLeaflet (timer, projId) {
            let params = { projId, pageId: this.pageId }
            let { data } = await pageApi.addLeaflet(params)
            if (data.isSuccess && data.data != -1) {
                this.progressOptions.percent = '100%'
                clearInterval(timer)
                setTimeout(() => {
                    this.progressOptions.showProgress = false
                    this.goTemplate(projId, data.data)
                }, 500)
            } else {
                this.$message.error('添加落地页失败')
            }
        },
        addProject (timer) {
            //判断是体验项目还是开通项目
            this.SET_IS_REFRESH(2)
            let experience = this.$route.params.experience || 1
            const replaceId = this.$route.params.replaceId
            let isNewSuit = this.$route.params.isNewSuit === 'true'
            const suitName = this.$route.params.suitName || ''
            let webType = this.webType

            let projData = {
                pageId: this.pageId,
                username: this.userInfo.username,
                uid: this.userInfo.uid,
                projType: this.projType,
                projName: this.tblName,
                webType,
                prodType: this.prodType,
                experience: Number(experience)
            }
            !(this.projType === '响应式') || (projData.suitName = suitName)

            replaceId === '0' || (projData.oldId = replaceId)
            !isNewSuit || (projData.newSuit = isNewSuit)
            if (this.isLandingPage) {
                this.addProjectLdy(timer, this.pageId)
                return
            }
            this.postCreateProject(projData).then(res => {
                if (res.data.isSuccess) {
                    this.progressOptions.percent = '100%'
                    clearInterval(timer)
                    setTimeout(() => {
                        this.progressOptions.showProgress = false
                        this.goTemplate(res.data.data.id)
                    }, 500)
                } else {
                    this.progressOptions.showProgress = false
                    clearInterval(timer)
                    this.openErrDialog('err', '操作信息提示', '', '', res.data.message, '确定', '', '', '')
                }
            })
        },
        addProjectLdy (timer, pageId) {
            const params = {
                projId: this.$route.query.projId,
                pageId,
            }
            this.userpageLdy(params).then(res => {
                if (res.data.isSuccess) {
                    this.progressOptions.percent = '100%'
                    clearInterval(timer)
                    setTimeout(() => {
                        this.progressOptions.showProgress = false
                        this.goTemplate(params.projId, res.data.data)
                    }, 500)
                } else {
                    this.progressOptions.showProgress = false
                    clearInterval(timer)
                    this.openErrDialog('err', '操作信息提示', '', '', res.data.message, '确定', '', '', '')
                }
            })

        },
        goTemplate (projId, pageId = '') {
            let type = this.projType === '手机' ? 'mctype' : 'pctype'
            pageId && window.sessionStorage.setItem('leafletPageId', pageId)
            this.SET_CUR_DEPUTY_NAV(pageId)
            let experience = this.$route.params.experience || 1 // 是否体验项目 '1'是 '0'否
            experience = this.isLandingPage ? '0' : experience
            let query = {
                edit: true,
                projId,
                type,
                prodType: this.prodType,
                experience
            }
            debugger
            if (this.$route.query.pageId !== '0' || this.isLandingPage) {
                query.pageId = this.$route.query.pageId || pageId
            }
            this.$router.replace({
                name: 'template',
                query
            })
        },
        getCancelPrompt () {
            this.guideMaskShow = false
            //不再显示提示
            this.getUpdTipStatus({
                type: 3
            }).then(res => {
                //更新用户信息
                this.getFrontUserInfo()
            })
        }
    },
    beforeRouteLeave (to, from, next) {
        sessionStorage.removeItem('experience')
        sessionStorage.removeItem('replaceId')
        next()
    }
}

</script>

<style lang="scss" scoped>
.ipad-img {
    position: absolute;
    top: 70px;
    left: 50%;
    bottom: 0;
    width: 980px;
    margin-left: -490px;
    border-radius: 55px 55px 0 0;
    background: #e3e3e3;
    &:before {
        content: "";
        display: block;
        width: 22px;
        height: 22px;
        margin: 28px auto;
        background: #fff;
        border-radius: 50%;
    }
}
.phone-img {
    position: absolute;
    top: 70px;
    left: 50%;
    bottom: 0;
    width: 368px;
    height: 680px;
    margin-left: -184px;
    border-radius: 30px;
    background: #e3e3e3;
    .phone-btn1 {
        position: relative;
        left: -2px;
        margin-top: 82px;
        width: 2px;
        height: 24px;
        border-radius: 2px 0 0 2px;
        background: #e3e3e3;
    }
    .phone-btn2 {
        position: relative;
        left: -2px;
        margin-top: 26px;
        width: 372px;
        height: 42px;
        border-radius: 2px;
        background: #e3e3e3;
    }
    .phone-btn3 {
        position: relative;
        left: -2px;
        margin-top: 12px;
        width: 2px;
        height: 42px;
        border-radius: 2px 0 0 2px;
        background: #e3e3e3;
    }
}

iframe {
    margin: 0 auto;
    width: 100%;
    &.has-padding {
        padding-top: 51px;
    }
    &.pc {
        padding-top: 51px;
    }
    &.ipad {
        position: absolute;
        top: 0px;
        left: 50%;
        width: 920px !important;
        padding-top: 150px;
        margin-left: -460px;
        z-index: 10;
    }
    &.phone {
        position: absolute;
        top: 84px;
        left: 50%;
        width: 340px !important;
        height: 648px;
        margin-left: -170px;
        z-index: 10;
        border-radius: 20px;
    }
}

.phone-bg {
    position: absolute;
    top: 84px;
    left: 50%;
    width: 340px;
    height: 648px;
    margin-left: -170px;
    z-index: 9;
    border-radius: 20px;
    background: #fff;
}
.ipad-bg {
    position: absolute;
    top: 150px;
    left: 50%;
    bottom: 0;
    width: 920px;
    margin-left: -460px;
    z-index: 9;
    background: #fff;
}

@media screen and (max-width: 1600px) {
    iframe.ipad {
        width: 680px !important;
        padding-top: 130px;
        margin-left: -340px;
    }
    .ipad-img {
        top: 70px;
        left: 50%;
        bottom: 0;
        width: 720px;
        margin-left: -360px;
    }
    .ipad-bg {
        top: 130px;
        width: 680px;
        margin-left: -340px;
    }
}

@media screen and (max-width: 1360px) {
    iframe.ipad {
        width: 610px !important;
        height: 100%;
        padding-top: 130px;
        margin-left: -305px;
    }
    .ipad-img {
        top: 70px;
        width: 640px;
        margin-left: -320px;
        &:before {
            width: 18px;
            height: 18px;
            margin: 24px auto;
        }
    }
    .ipad-bg {
        top: 130px;
        width: 610px;
        margin-left: -305px;
    }
}

.image-box {
    position: fixed;
    right: 50px;
    top: 35%;
    border: 1px solid #ccc;
    background: #fff;
    width: 270px;
    height: 270px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
        color: red;
        display: inline-block;
        margin-top: -13px;
    }
}

.preview-main-header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    border-bottom: 1px solid #dde1e2;
    box-shadow: 0 4px 5px rgba(0, 0, 0, 0.04);
    margin-bottom: 3px;
    background: #fff;
    z-index: 11;
    i {
        font-size: 20px;
        margin: 0 8px;
        cursor: pointer;
        color: #aaa;

        &.act {
            color: #111;
        }
    }
}

button {
    position: fixed;
    top: 30px;
    right: 30px;
    width: 150px;
    line-height: 49px;
    background: $colorA;
    color: #fff;
    border-radius: 4px;
    border: 0;
    z-index: 12;
    // &:hover {
    // 	background: #dd7900;
    // }
}

.pagehtml {
    height: 100%;
    background: #fff;
    &.pagehtml-bg {
        background: #f5f5f5;
        overflow: hidden;
        height: 100%;
    }
}

.guide-mask {
    position: fixed;
    cursor: pointer;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1000;

    img {
        position: absolute;
        top: 6px;
        right: 14px;
        width: 400px;
    }
}
</style>
